<div class="pm-form-field-custom-input-otp-container" #inputsContainer>
  @for (item of items(); track item) {
    <input
      pInputText
      #inputRef
      class="input-chunk"
      autocomplete="off"
      [maxLength]="1"
      [minLength]="1"
      (keyup)="onInputKeyup($event, item)"
      (input)="onInput($event, item)"
      inputmode="numeric"
      (paste)="onPaste($event)"
    />
  }
</div>
